export default "__VITE_PUBLIC_ASSET__bc8967cc__"